import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { compose, setObservableConfig } from 'recompose';
import SimpleForm from 'components/SimpleForm';
import SubmitButton from 'components/SubmitButton';
import CenteredLink from 'components/CenteredLink';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';


import { ROUTE_HOME, ROUTE_PASSWORD_FORGET, ROUTE_SIGN_UP, ROUTE_ADMIN } from 'routes/routes';
import SocialMediaLogin from 'components/SocialMediaLogin';
import withAuthorization from 'components/Session/withAuthorization';
import { useFirebase } from 'components/Firebase/context';

import Loader from '../../components/Loader';

const Login = ({ history }) => {
  const firebase = useFirebase();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorText, setErrorText] = useState(null);
  const [loader, setLoader] = useState(false);
  const isInvalid = password === '' || email === '';
  const onSubmit = () => {
    setLoader(true);
    firebase
      .doUserLogin(email, password)
      .then( async (authUser) => {
        if(authUser && authUser.user && authUser.user.uid ){
         const user = await firebase.getUserDataById(authUser.user.uid) .then( resp => { return resp.user || null})
         
            if(user){
            
               if(!user.roles){
                user.roles = {};
               }
               authUser = {
                uid: authUser.user.uid,
                email: authUser.user.email,
                ...user,
              };
              console.log('authUser2 ==>',authUser);
              setLoader(false);
              if(authUser.roles.ADMIN){
                history.push(ROUTE_ADMIN);
              }else{
                history.push(ROUTE_HOME);
              }
            }
        }
        console.log('authUser ==>',authUser);
        // setTimeout(
        //   function () {
        //     setLoader(false);
        //     history.push(ROUTE_HOME);
        //   }
        //     .bind(this),
        //   5000
        // );
      })
      .catch(error => {
        setLoader(false);
        setErrorText(error.message);
      });
  };
  return (
    <SimpleForm
      title="Login"
      errorText={errorText}
      footer={
        <>
          <Button
            fullWidth
            variant="contained"
            color="default"
            // @ts-ignore
            component={RouterLink}
            to={ROUTE_SIGN_UP}
          >
            Sign Up
          </Button>
        </>
      }
      onSubmit={onSubmit}
    >
      <SocialMediaLogin />
      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="email">Email Address</InputLabel>
        <Input
          id="email"
          name="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          autoComplete="email"
          autoFocus
        />
      </FormControl>
      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="password">Password</InputLabel>
        <Input
          id="password"
          name="password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
        />
      </FormControl>
      <SubmitButton disabled={isInvalid}>{loader ? <Loader /> : 'Sign In'}</SubmitButton>
      <CenteredLink component={RouterLink} to={ROUTE_PASSWORD_FORGET}>
        Forgot Password?
      </CenteredLink>
    </SimpleForm>
  );
};

// @ts-ignore
export default compose(
  withRouter,
  withAuthorization(authUser => authUser === null)
)(Login);
